import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SafetyHint } from '@ecs-services/safety-hint/safety-hint.interface';
import { SafetyHintService } from '@ecs-services/safety-hint/safety-hint.service';
import { SerialNumberSearchResult } from '@ecs-services/search/search.interface';
import { Observable } from 'rxjs';
import { SafetyHintTagComponent } from '../safety-hint-tag/safety-hint-tag.component';

@Component({
    selector: 'ecs-safety-hint-tag-list',
    templateUrl: './safety-hint-tag-list.component.html',
    styleUrls: ['./safety-hint-tag-list.component.scss'],
    imports: [SafetyHintTagComponent, AsyncPipe],
})
export class SafetyHintTagListComponent implements OnInit {
    @Input() public searchResult?: SerialNumberSearchResult;

    public safetyHints?: Observable<SafetyHint[]> | null;
    public lastSafetyHintsConfirmed = 0;

    public constructor(private safetyHintService: SafetyHintService) {}

    public ngOnInit(): void {
        this.safetyHints = this.safetyHintService.getTranslatedHints(this.searchResult);
    }

    public setLastSafetyHintConfirmed(index: number) {
        if (index > this.lastSafetyHintsConfirmed) {
            this.lastSafetyHintsConfirmed = index;
        }
    }
}
